export default `:host([auto-fit]) {
  height: 100%;
}

:host([auto-fit]) ::slotted(.ids-tabs-content) {
  height: 100%;
}

.orientation-vertical {
  display: flex;
}

.auto-fit {
  height: 100%;
}

:host ids-header {
  position: sticky;
  top: 0;
  z-index: 30;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  display: flex;
  flex-direction: column;
  block-size: 100%;
  min-block-size: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGFicyIsInNvdXJjZXMiOlsiaWRzLXRhYnMtY29udGV4dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUlBO0VBQ0U7RUFDQTtFQUNBOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiXG46aG9zdChbYXV0by1maXRdKSB7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuOmhvc3QoW2F1dG8tZml0XSkgOjpzbG90dGVkKC5pZHMtdGFicy1jb250ZW50KSB7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLm9yaWVudGF0aW9uLXZlcnRpY2FsIHtcbiAgZGlzcGxheTogZmxleDtcbn1cblxuLmF1dG8tZml0IHtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG46aG9zdCB7XG4gIGlkcy1oZWFkZXIge1xuICAgIHBvc2l0aW9uOiBzdGlja3k7XG4gICAgdG9wOiAwO1xuICAgIHotaW5kZXg6IDMwO1xuICB9XG59XG5cbjpob3N0KC5pZHMtZGF0YS1ncmlkLXN0aWNreS1sYXlvdXQtYW5jZXN0b3IpIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYmxvY2stc2l6ZTogMTAwJTtcbiAgbWluLWJsb2NrLXNpemU6IDA7XG59XG4iXX0= */`;
